import { z } from 'zod';

export const CalibrationPacketSchema = z.object({
  device: z.string(),
  movement: z.number(),
});

export type CalibrationPacket = z.infer<typeof CalibrationPacketSchema>;
